<template>
  <div class="hello">
    <div class="ind_rgba" :class="{ind_rgba_ac:toggle==true}" @click="qieh"></div>
    <div class="ind_head">
      <div class="ind_head_n">
        <div class="ind_head_l">
          <a class="ind_head_l_a" href="javascript:;"><img src="../../static/img/logo.png"/></a>
          <span class="logo_desc">论文查重平台</span>
          <div class="clear"></div>
        </div>
        <div class="sj_qiehuan" @click="qieh"><img src="../../static/img/icon10.png"></div>

        <div class="ind_head_r" :class="{ind_head_r_ac:toggle==true}">
          <ul class="ind_head_ul">
            <li v-for="(key,idx) in navlist" class="headerList">
              <a class="headerLista" :href="key.url" :target="key.targetopt" v-if="key.url[0]!='/'">{{key.name}}</a>
              <router-link :to="key.url" :target="key.targetopt" v-else>{{key.name}}</router-link>
            </li>
            <div class="clear"></div>
          </ul>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import { defaultData } from "../assets/js/common.js";

export default {
  name: "HelloWorld",
  data() {
    return {
      toggle: false,
      num: 1,
      navlist: [
        { name: "首页", url: "/", targetopt: "_self" },
        { name: "验证真伪", url: "/verify", targetopt: "_self" },
        { name: "机构版", url: "/jigou", targetopt: "_self" },
        { name: "关于我们", url: "/aboutus", targetopt: "_self" },
      ],
      linum: 0,
    };
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.styleInit();
      })()
    }
    this.styleInit();
  },
  methods: {
    qieh() {
      this.toggle = !this.toggle;
    },
    styleInit() {
      var clientWidth = document.body.clientWidth;
    var ind_head = document.getElementsByClassName("ind_head")[0].style;
    ind_head.height = clientWidth * (70.37/1903)+"px";

    var ind_head_l = document.getElementsByClassName("ind_head_l")[0].style;
    ind_head_l.width = clientWidth * (500/1903)+"px";

    var ind_head_l_a = document.getElementsByClassName("ind_head_l_a")[0].style;
    ind_head_l_a.width = clientWidth * (284/1903)+"px";
    ind_head_l_a.height = clientWidth * (28/1903)+"px";
    ind_head_l_a.marginTop = clientWidth * (21.81/1903)+"px";

    var logo_desc = document.getElementsByClassName("logo_desc")[0].style;
    logo_desc.lineHeight = clientWidth * (27.75/1903)+"px";
    logo_desc.height = clientWidth * (27.75/1903)+"px";
    logo_desc.width = clientWidth * (150.17/1903)+"px";
    logo_desc.marginLeft = clientWidth * (10.09/1903)+"px";
    logo_desc.fontSize = clientWidth * (16/1903)+"px";
    logo_desc.marginTop = clientWidth * (21.81/1903)+"px";

    var ind_head_r = document.getElementsByClassName("ind_head_r")[0].style;
    ind_head_r.height = clientWidth * (70.37/1903)+"px";

    var ind_head_ul = document.getElementsByClassName("ind_head_ul")[0].style;
    ind_head_ul.marginTop = clientWidth * (0)+"px";
    ind_head_ul.height = clientWidth * (70.37/1903)+"px";
    //.children[0]

    var headerList = document.getElementsByClassName("headerList");
    for(var i = 0; i < headerList.length; i++ ) {
      headerList.item(i).style.height = clientWidth * (70.37/1903)+"px";
      headerList.item(i).style.marginLeft = clientWidth * (80.28/1903)+"px";
      headerList.item(i).style.fontSize = clientWidth * (16/1903)+"px";
      headerList.item(i).children[0].style.fontSize = clientWidth * (16/1903)+"px";
      headerList.item(i).children[0].style.lineHeight = clientWidth * (70.37/1903)+"px";
      headerList.item(i).children[0].style.height = clientWidth * (70.37/1903)+"px";
      headerList.item(i).children[0].style.display = 'block';
    }

    document.styleSheets[0].addRule('.ind_head_r .router-link-exact-active:after', 'bottom:'+clientWidth * (11.6/1903)+"px"+' !important;');
    document.styleSheets[0].addRule('.ind_head_r .router-link-exact-active:after', 'height:'+clientWidth * (4/1903)+"px !important;");

    document.styleSheets[0].addRule('.ind_head_r ul li>a:hover:after', 'bottom:'+clientWidth * (11.6/1903)+"px"+' !important;');
    document.styleSheets[0].addRule('.ind_head_r ul li>a:hover:after', 'height:'+clientWidth * (4/1903)+"px !important;");
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo_desc{
  font-family: PingFangSC-Medium,微软雅黑;
}
.ind_head_r ul li>a{
  font-family: PingFangSC-Regular,微软雅黑;
}
</style>



// WEBPACK FOOTER //
// src/components/Headerr.vue